import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Modal, Divider, Icon, Button } from 'semantic-ui-react';
import { DyzioModalHeader } from 'dyzio-shared-components/lib/components/dyzio-modal';
import hasRESTClient from '../../hocs/has-rest-client';

const grayStyle = {
  color: '#333',
};

const textAlignCenter = {
  textAlign: 'center',
};

export const getSuccessMessage = (processedInvitations = []) => {
  const names = _.map(processedInvitations.invitations, 'attributes.name');
  if (_.isEmpty(names)) {
    return 'no emails sent';
  }
  if (_.size(names) === 1) {
    return `email sent to ${_.head(names)}`;
  }
  if (_.size(names) === 2) {
    return `emails sent to ${_.nth(names, 0)} and ${_.nth(names, 1)}`;
  }
  return `emails sent to ${_.nth(names, 0)}, ${_.nth(names, 1)} and ${_.size(names) - 2} more`;
};

class ChaseEmailSendModal extends Component {
  constructor(props) {
    super(props);
    const { buildRESTClient } = props;
    this.state = {
      sentOK: false,
      requestRunning: false,
      requestFailed: false,
    };
    this.apiClient = buildRESTClient({
      baseURL: process.env.REACT_APP_CAMPAIGN_AUTOMATION_URL,
    });
  }

  handleClick = async () => {
    const { campaignId } = this.props;
    this.setState({
      requestRunning: true,
    });
    const response = await this.apiClient.post('campaign/chase', {
      data: {
        campaign: {
          id: campaignId,
        },
      },
    }).catch(() => {
      this.setState({
        sentOK: false,
        requestRunning: false,
        requestFailed: true,
      });
    });
    if (response) {
      this.setState({
        sentOK: true,
        requestRunning: false,
        requestFailed: false,
        processedInvitations: _.get(response, 'data.data', []),
      });
    }
  }

  render() {
    const { onClose } = this.props;
    const { requestRunning, requestFailed, sentOK, processedInvitations } = this.state;
    return (
      <Modal
        open
        size="tiny"
        closeOnEscape
        closeOnDimmerClick
        onClose={onClose}
      >
        <DyzioModalHeader onClose={onClose} headerText="Send chase email" />
        <Modal.Content style={textAlignCenter}>
          <Icon
            name={requestRunning ? 'spinner' : 'send'}
            active={requestRunning}
            color={sentOK ? 'green' : 'orange'}
            size="huge"
          />
          <Divider hidden clearing />

          {
            sentOK && <h3>{getSuccessMessage(processedInvitations)}</h3>
          }

          {
            !sentOK && !requestFailed && <h3 style={grayStyle}>do you really want to send chase emails <br />to all influencers from this campaign?</h3>
          }

          <Divider hidden />
          <Button icon labelPosition="left" color="pink" fluid onClick={sentOK || requestFailed ? onClose : this.handleClick}>
            <Icon name="checkmark" />
            { sentOK ? 'OK' : 'Send'}
          </Button>
        </Modal.Content>
      </Modal>
    );
  }
}

ChaseEmailSendModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  campaignId: PropTypes.string.isRequired,
  buildRESTClient: PropTypes.func.isRequired,
};

export default hasRESTClient(ChaseEmailSendModal);



/** WEBPACK FOOTER **
 ** ./src/components/chase-email-send-modal/index.js
 **/